import React from 'react'
import AlertIcon from 'react-icons/lib/io/android-alert'
import CheckIcon from 'react-icons/lib/io/checkmark-circled'
import InfoCircledIcon from 'react-icons/lib/io/informatcircled'
import LockedIcon from 'react-icons/lib/io/locked'
import startCase from 'lodash/startCase'

import { pure } from 'recompose'

import Modal from './Modal'

import {
  CloseButton
} from './Controls'

import * as Panel from './Panel'

import { preventDefault } from '../utils/events'

import './StatusMessage.css'
import cx from 'classnames'

import * as Status from './StatusMessage'

export default class StatusMessage extends React.PureComponent {
  state = {
    open: false
  }

  render () {
    const { Icon, title, children, className, detail } = this.props
    const subtitle = this.props.subtitle ? <span className='subtitle'>{this.props.subtitle}</span> : ''
    const Detail = detail
    return (
      <div className={cx('StatusMessage', className)}>
        <div className='IconContainer'><Icon /></div>
        <div className='statusMessageInner'>
          <h3>{title}{(title && this.props.subtitle) ? ' - ' : ''}{subtitle}</h3>
          <div className='statusMessageContent'>
            {children}
          </div>
          {!Detail ? null : (
            <div className='statusMessageDetail'>
              <a onClick={preventDefault(() => this.setState({ open: true }))}>More Info</a>
              <Modal isOpen={this.state.open} className='small'>
                <Panel.Pane>
                  <Panel.Header3>
                    <div />
                    <h3>{title}</h3>
                    <CloseButton onClick={preventDefault(() => this.setState({ open: false }))} />
                  </Panel.Header3>
                  <Panel.Content>
                    <StatusMessage {...this.props} title={''} detail={false}>
                      <Detail {...this.props} />
                    </StatusMessage>
                  </Panel.Content>
                </Panel.Pane>
              </Modal>
            </div>
          )}
        </div>
      </div>
    )
  }
}

StatusMessage.defaultProps = {
  title: '',
  subtitle: ''
}

export const ConsoleOutput = pure(function ConsoleOutput ({ className, ...props }) {
  return (
    <div className={cx('ConsoleOutput', className)} {...props} />
  )
})

export const InfoMessage = pure(function InfoMessage ({ className, ...props }) {
  return <StatusMessage className={cx('InfoMessage', className)} title='' Icon={InfoIcon} {...props} />
})

export const NotFoundMessage = pure(function NotFoundMessage ({ className, ...props }) {
  return <StatusMessage className={cx('NotFoundMessage', className)} title='Not Found' Icon={WarnIcon} {...props} />
})

export const ErrorMessage = pure(function ErrorMessage ({ className, error, ...props }) {
  return <StatusMessage className={cx('ErrorMessage', className)} title={getStatusMessage(error)} Icon={ErrorIcon} {...props} />
})

export const WaitMessage = pure(function WaitMessage ({ className, ...props }) {
  return <StatusMessage className={cx('WaitMessage', className)} title='Please Wait…' Icon={WaitIcon} {...props} />
})

export const SuccessMessage = pure(function SuccessMessage ({ className, ...props }) {
  return <StatusMessage className={cx('SuccessMessage', className)} title='Success' Icon={SuccessIcon} {...props} />
})

export const WarnMessage = pure(function WarnMessage ({ className, ...props }) {
  return <StatusMessage className={cx('WarnMessage', className)} title='Warning' Icon={WarnIcon} {...props} />
})

export const AccessDeniedMessage = pure(function AccessDeniedMessage ({ className, ...props }) {
  return <ErrorMessage className={cx('AccessDeniedMessage', className)} title='Restricted' Icon={AccessDeniedIcon} {...props} />
})

export function ErrorIcon ({ className, ...props }) {
  return <AlertIcon className={cx('Icon', 'ErrorIcon', className)} {...props} />
}

export function AccessDeniedIcon ({ className, ...props }) {
  return <LockedIcon className={cx('Icon', 'AccessDeniedIcon', className)} {...props} />
}

export function WarnIcon ({ className, ...props }) {
  return <AlertIcon className={cx('Icon', 'WarnIcon', className)} {...props} />
}

export function SuccessIcon ({ className, ...props }) {
  return <CheckIcon className={cx('Icon', 'SuccessIcon', className)} {...props} />
}

export function WaitIcon ({ className, ...props }) {
  return (
    <div className={cx('Icon WaitIcon LoaderIcon', className)} {...props}>
      <svg className='circular-loader' viewBox='25 25 50 50' >
        <circle className='loader-path' cx='50' cy='50' r='20' fill='none' stroke='currentColor' strokeWidth='5' />
      </svg>
    </div>
  )
}

export function InfoIcon ({ className, ...props }) {
  return <InfoCircledIcon className={cx('Icon', 'InfoIcon', className)} {...props} />
}

export function getSubtitle (error) {
  if (!error.response) return ''
  return `${error.response.status} ${error.response.statusText}`.trim()
}

export function getStatusMessage (error) {
  if (!error) return
  if (error.response) {
    if (error.response.data && error.response.data.message) {
      return `${error.response.statusText}: ${error.response.data.message}`
    }
    const url = error.response.url || (error.response.config && error.response.config.url)
    return `${error.response.statusText}: ${cleanURL(url)}`.trim()
  }
  if (typeof error.details === 'string') {
    return error.details
  }
  if (error.error) {
    return getStatusMessage(error.error)
  }
  return (error.message || String(error)).split('\n')[0].slice(0, 255)
}

export function Select ({ type, ...props }) {
  const Message = Status[startCase(type)] || StatusMessage
  return <Message {...props} />
}

function cleanURL (url = '') {
  return url.replace(window.location.origin, '')
}

export {
  ErrorMessage as Error,
  SuccessMessage as Success,
  WaitMessage as Wait,
  WarnMessage as Warn,
  InfoMessage as Info,
  StatusMessage as Status,
  StatusMessage as Message,
  NotFoundMessage as NotFound,
  AccessDeniedMessage as AccessDenied
}



// WEBPACK FOOTER //
// ./src/components/StatusMessage.js